<template>
  <div>
    <el-form label-position="right" ref="form" :model="form.model" :rules="formRules" :validate-on-rule-change="false" label-width="120px">
      <el-row class="bottom20">
        <el-row class="column-name" justify="start">
          <span>基本信息</span>
        </el-row>
        <el-row>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="报告编号" prop="code">
              <el-input v-model="form.model.code" :disabled="true" maxlength="30" placeholder="系统自动生成" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="报告名称" prop="name">
              <el-input v-model="form.model.name" :disabled="!editable" maxlength="60" placeholder="限60个字符" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="数据中心" prop="roomId">
              <dictionary-select v-model="form.model.roomId" @change="form.model.siteId = $event[1]['']" :disabled="!editable" :factory-name="'room'" :params="{type: 'AUTH_SITE'}" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="故障等级" prop="failureLevel">
              <dictionary-select v-model="form.model.failureLevel" :disabled="!editable" :factory-name="'domain'" :params="'RPLEVEL'" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="故障位置" prop="failureLocation">
              <location-picker :text="form.model.failureLocationDescription" :search="{roomid: form.model.roomId}" @change="selectLocation" :disabled="!editable" size="small"></location-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="故障类型" prop="failureType">
              <dictionary-select ref="failureTypeRef" v-model="form.model.failureType" :disabled="!editable" :factory-name="'domain'" :params="'ASSETTYPE'" clearable filterable size="small"></dictionary-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="故障开始时间" prop="failureStartTime">
              <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              v-model="form.model.failureStartTime"
                              type="datetime" :disabled="!editable"
                              placeholder="故障开始时间" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="故障恢复时间" prop="failureRecoverTime">
              <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                              v-model="form.model.failureRecoverTime"
                              type="datetime" :disabled="!editable"
                              placeholder="故障恢复时间" size="small">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="报告制作人" prop="reporter">
              <room-user-select v-model="form.model.reporter" @change="form.model.reporterName = $event[1]"
                             :room-id="form.model.roomId" :disabled="!editable" v-if="editable"
                             :filterable="true" :clearable="true" size="small"></room-user-select>
              <el-input v-model="form.model.reporterName" :disabled="!editable" v-if="!editable" size="small"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12">
            <el-form-item label="关键词" prop="keywordsView">
              <el-select ref="keywordsViewRef" v-model="form.model.keywordsView" size="small"
                         multiple
                         filterable
                         remote
                         :remote-method="handleKeywordSearch"
                         :loading="keywordSearchLoading"
                         allow-create
                         default-first-option
                         :disabled="!keywordsEditable"
                         placeholder="请输入关键词，按回车添加" class="width100">
                <el-option v-for="keyword in keywordRange" :key="keyword.description" :label="keyword.description" :value="keyword.description"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-row>
    </el-form>

    <el-row class="bottom20" v-if="isVendor && form.model.id != null">
      <el-row class="column-name" justify="start">
        <span>故障详情</span>
        <div class="navbar-right">
          <el-button type="info" plain size="minimum" @click="toUploadPDFInVendor" :disabled="!(form.model.id != null && form.model.status === 'DRAFT')" v-if="hasPermission('menu.review.crud')">上传PDF</el-button>
          <input ref="pdfInput" type="file" accept=".pdf" style="display: none;" @change="uploadPDFInVendor"></input>
        </div>
      </el-row>
      <el-row>
        <pdf-viewer :url="pdfUrl" :percent-width="pdfViewerWidth"></pdf-viewer>
      </el-row>
    </el-row>

    <!-- 附件 -->
    <Attachment ownerTable='REVIEWREPORT'
                docType='REVIEWREPORT'
                :ownerId='form.model.id'
                :existed="form.model.id != null"
                :disabled="!(form.model.id != null && form.model.status === 'DRAFT' && hasPermission('menu.review.crud'))" :addable="hasPermission('menu.review.crud')"></Attachment>

    <!-- 流转信息 -->
    <el-row v-if="form.model.id != null">
      <el-row class="column-name" justify="start">
        <span>流转信息</span>
      </el-row>
      <el-row>
        <Workflow ref="workflowHistory" :bussiness="workflowBusiness" :bussinessId="form.model.id" @loaded="workflowHistoryLoaded"></Workflow>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  import Emitter from 'element-ui/src/mixins/emitter'
  import Attachment from '@/components/attachment'
  import Workflow from '@/components/workflow'
  import ReviewServer from '@/api/review'
  // import {debounce, merge} from '@/util/common'
  import '@/util/common/date'
  import {parseDate} from 'element-ui/lib/utils/date-util'
  // import {AuthInfo} from '@/util/user/authInfo'
  // import {Dictionary, dictionaryContainer} from '@/util/common/dictionary'

  import DictionarySelect from "@/components/common/DictionarySelect";

  import LocationPicker from '@/components/common/LocationPicker';
  import RoomUserSelect from '@/components/common/RoomUserSelect'
  import KnowledgeServer from '@/api/knowledge'
  import PDFViewer from '@/components/common/PDFViewer'

  import {ATTACHMENT_SERVER} from '@/api/server';
  import AttachmentServer from '@/api/attachment';

  import ReviewReportTypeMixin from './mixins/review-report-type'

  export default {
    name: "ReviewReportDetail",
    mixins: [Emitter, ReviewReportTypeMixin],
    components: {
      DictionarySelect,
      Attachment, Workflow, LocationPicker, RoomUserSelect,
      'pdf-viewer': PDFViewer
    },
    props: {
      operation: {
        type: String,
        default: 'detail.show'
      },
      data: {
        type: Object
      },
    },
    data() {
      return {
        op: 'show', // show, add, edit
        locationSelectDialogVisible: false,
        pdfUrl: null,
        pdfViewerWidth: 100,
        form: {
          model: {
            id: null,
            code: '',
            name: '',
            roomId: '',
            failureLevel: '',
            failureLocation: '',
            failureLocationDescription: '',
            failureType: '',
            failureStartTime: null,
            failureRecoverTime: null,
            reporter: null,
            reporterName: null,
            keywordsView: [],
            status: '',
            type: '',
            deleted: 0
          },
        },
        keywordRange: [],
        keywordSearchLoading: false,
      }
    },
    computed: {
      type() {
        return this.data.type;
      },
      formRules() {
        let failureTimeValidator = (callback, message) => {
          let failureStartTime = this.form.model.failureStartTime;
          let failureRecoverTime = this.form.model.failureRecoverTime;
          if (failureStartTime != null && failureStartTime.trim() !== '' &&
              failureRecoverTime != null && failureRecoverTime.trim() !== '' &&
              parseDate(failureStartTime, 'yyyy-MM-dd HH:mm:ss').getTime() > parseDate(failureRecoverTime, 'yyyy-MM-dd HH:mm:ss').getTime()) {
            callback(message);
          } else {
            callback();
          }
        };

        return {
          name: [
            { type: 'string', required: true, message: '请输入报告名称', trigger: 'blur' },
            { max: 60, message: '限60个字符', trigger: 'blur' },
          ],
          roomId: [
            { required: true, message: '请选择数据中心', trigger: 'change' }
          ],
          failureLevel: [
            { required: true, message: '请选择故障等级', trigger: 'change' }
          ],
          failureStartTime: [
            { required: true, message: '请输入故障开始时间', trigger: 'change' },
            { trigger: 'change',
              validator: (rule, value, callback) => {
                failureTimeValidator(callback, '故障开始时间应小于故障恢复时间');
              }
            }
          ],
          failureRecoverTime: [
            { required: true, message: '请输入故障恢复时间', trigger: 'change' },
            { trigger: 'change',
              validator: (rule, value, callback) => {
                failureTimeValidator(callback, '故障恢复时间应大于等于故障开始时间');
              }
            }
          ],
          reporter: [
            { required: true, message: '请选择报告制作人', trigger: 'change' }
          ],
          keywordsView: [
            { required: true, message: '请添加关键词', trigger: 'change' }
          ]
        };
      },
      defaultStatus() {
        let status = null;
        if (this.op === 'detail.add') {
          status = 'DRAFT';
        }
        return status;
      },
      editable() {
        return (this.op === 'detail.add' || this.op === 'detail.edit' && this.form.model.id != null && this.form.model.status === 'DRAFT');
      },
      keywordsEditable() {
        return (this.op === 'detail.add' || this.op === 'detail.edit' && this.form.model.id != null);
      },
      workflowBusiness() {
        return this.data.type === 'SPECIAL' ? 'SPECIALPROCESS' : 'VENDORPROCESS';
      },
    },
    watch: {
      operation: {
        handler(value) {
          this.op = value;
        }
      },
      op: {
        handler(value) {
          this.$emit('switch-operation', value);
        }
      },
      data: {
        deep: true,
        handler(value, old) {
          if (value['id'] == null) {
            this.form.model = {
              id: null,
              code: '',
              name: '',
              roomId: '',
              failureLevel: '',
              failureLocation: '',
              failureLocationDescription: '',
              failureType: '',
              failureStartTime: null,
              failureRecoverTime: null,
              reporter: null,
              reporterName: null,
              keywordsView: [],
              status: value['status'],
              type: value['type'],
              deleted: 0,
            };
            this.$nextTick(() => {
              this.$refs.form.clearValidate();
            });
          } else {
            ReviewServer.reviewReport.get(value['id']).then((res) => {
              if (res.data.code === 200) {
                this.form.model = this._toModel(res.data.result);
              }
            })
          }

          if (value['status'] !== old['status']) {
            if (this.$refs.workflowHistory != null) {
              this.$refs.workflowHistory.getHistoryList();
            }
          }
        }
      },
      'form.model.id': {
        immediate: true,
        handler(value) {
          this.pdfUrl = null;
          if (value != null) {
            if (this.isVendor && this.form.model.id != null) {
              this.getPDFInVendor();
            }
          }
        }
      },
      'form.model.failureType': {
        handler(value, old) {
          if (this.operation === 'detail.add' || this.operation === 'detail.edit') {
            let valueText = this.$refs['failureTypeRef'].innerDictionary.getText(value);
            let oldText = this.$refs['failureTypeRef'].innerDictionary.getText(old);
            this.setDefaultKeywords(valueText, oldText);
          }
        }
      },
      defaultStatus: {
        immediate: true,
        handler() {
          if (this.defaultStatus != null) {
            this.form.model.status = this.defaultStatus;
          }
        }
      },
      'keywordsEditable': {
        handler(value) {
          this.setElementUiSelectPlaceholder('keywordsViewRef', this.form.model.keywordsView, !this.keywordsEditable);
        }
      },
      'form.model.keywordsView': {
        handler(value) {
          this.setElementUiSelectPlaceholder('keywordsViewRef', this.form.model.keywordsView, !this.keywordsEditable);
        }
      }
    },
    methods: {
      setElementUiSelectPlaceholder(refName, vModelValue, disabled) {
        let el = this.$refs[refName].$el;
        let input = el.querySelector('input.el-select__input');
        let placeholder = vModelValue == null || vModelValue.length <= 0 || disabled ? '' : '请输入关键词，按回车添加';
        input.setAttribute('placeholder', placeholder);
      },
      init(options) {

      },
      loadFormModel(id) {
        ReviewServer.reviewReport.get(id).then((res) => {
          if (res.data.code === 200) {
            this.form.model = this._toModel(res.data.result);
          }
        })
      },
      selectLocation(location) {
        this.form.model.failureLocation = location['locationid'];
        this.form.model.failureLocationDescription = location['description'];
      },
      setDefaultKeywords(value, old) {
        if (value != old) {
          let keywords = this.form.model.keywordsView;
          if (keywords == null) {
            keywords = [];
          }
          let oldIndex;
          if (old != null && old.trim() !== '' && (oldIndex = keywords.indexOf(old)) !== -1) {
            keywords.splice(oldIndex, 1);
          }
          if (value != null && value.trim() !== '') {
            keywords.push(value);
          }
          // this.form.model.keywordsView = keywords;
          this.$set(this.form.model, 'keywordsView', keywords)
        }

      },
      toUploadPDFInVendor() {
        this.$refs['pdfInput'].click();
      },
      uploadPDFInVendor() {
        let file = this.$refs['pdfInput'].files[0];
        if (file.type !== 'application/pdf') {
          this.$message.error('请选择PDF文件上传！');
          return;
        }
        let params = {
          file: file,
          ownerTable: 'RVWRPTVDPDF',
          docType: 'RVWRPTVDPDF',
          ownerId: this.form.model['id'],
        }
        AttachmentServer.attachment.upload(params).then(responseBody => {
          this.$message("上传成功");
          this.getPDFInVendor();
        })
      },
      getPDFInVendor() {
        let params = {
          ownerTable: 'RVWRPTVDPDF',
          ownerId: this.form.model['id'],
        }
        AttachmentServer.attachment.downloadList(params).then((attachments) => {
          if (attachments != null && attachments.length > 0) {
            let lastAttachment = attachments[attachments.length - 1];
            this.pdfUrl = lastAttachment.url;
            this.pdfViewerWidth = null;
            this.$nextTick(() => {
              this.pdfViewerWidth = 100;
            });
          }
        });
      },
      handleKeywordSearch(term) {
        if (term !== '') {
          this.keywordSearchLoading = true;
          KnowledgeServer.keywordApi.list({
            like_description: term
          }).then((data) => {
            this.keywordSearchLoading = false;
            this.keywordRange = data.data.result;
          });
        } else {
          this.keywordRange = [];
        }
      },
      saveAdd() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            ReviewServer.reviewReport.add(
                data, {loading: true}
            ).then((res) => {
              if (res.data.code === 200) {
                this.op = 'detail.show';
                this.$message.success('保存成功');

                let model = this._toModel(res.data.result);
                this.form.model = model;
                this.$emit('detail-change', model);
              }
            });
          } else {
            return false;
          }
        });
      },
      saveEdit() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = this._toData(this.form.model);
            ReviewServer.reviewReport.update(
                data['id'], data, {loading: true}
            ).then((res) => {
              if (res.data.code === 200) {
                this.op = 'detail.show';
                this.$message.success('保存成功');

                let model = this._toModel(res.data.result);
                this.form.model = model;
                this.$emit('detail-change', model);
              } else {
                this.$message.error(res.data.message);
              }
            });
          } else {
            return false;
          }
        });
      },
      cancelEdit() {
        this.op = 'detail.show';
        this.$refs['form'].resetFields();
        this.loadFormModel(this.data['id']);
      },
      remove() {
        this.$confirm('确定删除吗？', '删除提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ReviewServer.reviewReport.delete(this.form.model['id'], {loading: true}).then((res) => {
            if (res.data.code === 200) {
              this.dispatch('ReviewReportMain', 'switch-operation', 'list.query');
              this.dispatch('ReviewReportMain', 'switch-tab', 'list');
              this.$message.success('删除成功！');
            } else {
              this.$message.error(`删除失败：${res.data.message}`);
            }
          });
        }, () => {})
      },

      workflowHistoryLoaded(histories) {
        this.$emit('workflow-history-loaded', histories);
      },
      _toModel(data) {
        data.keywordsView = data.keywords == null ? [] : JSON.parse(data.keywords);
        return data;
      },

      _toData(model) {
        model.keywords = model.keywordsView == null ? null : JSON.stringify(model.keywordsView);
        return model;
      }
    },
    mounted() {
      /*this.pdfSrc.then(pdf => {
        this.numPages = pdf.numPages;
      });*/
    }
  }
</script>

<style scoped>

</style>
